<template>
  <div class="container" v-if="!isMobile && !isTencent">
    <base-header v-if="showBaseHeader || currentRoute === '/companyList' || isShowReportAnalyze"/>
    <div class="top-nav-view" v-else>
      <div class="left-top-view">
        <logo :imgIcon="headerLogo" :customLogo="isEnterpriseLogo" @clickLogo="clickLogo"
              :style="{cursor: currentRoute == '/companyList' || isShowBackBtn ? 'inherit' : 'pointer'} "></logo>
        <div class="space_block"></div>
        <header-tab
          :common-authority="commonAuthority"
          :get-user-auther-router="getUserAutherRouter"
          @tabClick="tabClick"
        />
      </div>
      <div class="right-top-view" v-if="currentRoute != '/companyList' && !isShowReportAnalyze && !isShowBackBtn ">
        <dropMenu v-if="!ifMainlandVersion" :menuInfo="languageMenu"/>
        <dropMenu :menuInfo="userMenu" @dropCommand="userDrop"/>
      </div>
    </div>
  </div>
</template>

<script>
import {buriedOperatingPoint} from '@/utils/applicationTool'
import {checkToolsAuthority} from '@/api/applicationTool'
import dropMenu from '@/components/home/dropMenu.vue'
import {logout} from '@/api/user'
import {projectProgress} from '@/api/applicationTool'
import {
  getStore,
  setStore,
  removeStore,
  clone,
  getSession,
  getPrivacy,
  getTerms,
  getImageLanguage,
  isMobile,
  removeSession,
  setSession
} from '@/utils/index'
import {mapGetters} from 'vuex'
import BaseHeader from "./BaseHeader";
import logo from "@/components/home/logo.vue";
import HeaderTab from "./HeaderTab";

export default {
  inject: {
    enterpriseContentState: {
      default: () => ({ pcLogoUrl: '' })
    }
  },
  props: {},
  watch: {
    $route(val, old) {
      console.log('Header监听路由切换', val)
      this.currentRoute = val.path
      this.currentRouteName = val.name

      this.getUserAutherRouter = getSession('getUserAutherRouter');//每次路由切换都更新一下高亮状态
      console.log('this.getUserAutherRouter', this.getUserAutherRouter)
      this.refreshUserMenu()
      if (old.path == '/companyList') {
        //这里从公司列表切换路由时重新更新一下权限，因为权限会在选择公司后重新获取
        this.commonAuthority = getStore('userAuthority') ? JSON.parse(getStore('userAuthority')) : this.$store.state.user.userAuthority;

        if (this.commonAuthority.toolsAuthority) {
          this.haveToolsAuthority()
        }
      }
      if ((this.$route.query.linksource && this.$route.query.linksource == 'third') || sessionStorage.getItem('isShowBackList')) {
        this.setheader()
      }
    },
  },

  computed: {
    isEnterpriseLogo() {
      return !!(this.enterpriseContentState && this.enterpriseContentState.pcLogoUrl)
    },
    headerLogo() {
      return this.enterpriseContentState && this.enterpriseContentState.pcLogoUrl ? this.enterpriseContentState.pcLogoUrl : this.imgIcon
    },
    courseList: function () {
      const self = this
      if (this.$store.state.user.courseList.length == 0) {
        self.$store.dispatch(
          'setCourseList',
          getSession('courseList') ? JSON.parse(getSession('courseList')) : []
        )
      }
      this.$forceUpdate()
      return this.$store.state.user.courseList
    },
  },
  data() {
    return {
      isTencent: !!getSession('txModuleId'), //是否腾讯对接
      isMobile: isMobile(),
      imgIcon: require('../../assets/image/home/logo.png'),
      userMenu: {
        type: 'user',
        dropArr: [],
      },
      currentRouteName: '',
      currentRoute: '',
      languageMenu: {
        type: 'language',
        defaultValue: this.$t('language'),
        dropArr: [
          {
            name: '中文简体',
            action: 'chinese',
            value: 'zh_CN',
          },
          {
            name: 'English',
            action: 'english',
            value: 'en_US',
          },
          {
            name: '中文繁體',
            action: 'traditional',
            value: 'zh_TW',
          },
          {
            name: 'ภาษาไทย',
            action: 'thai',
            value: 'th_TH',
          },
        ],
      },
      userInfo: {},
      commonAuthority: {},// 当前用户的权限：学习中心、教练、工具
      getUserAutherRouter: null,//当前高亮的tab，默认学习中心
      ifMainlandVersion: false, // 是否是大陆版 true--是
      // isShowHeadre: true,  // 是否显示头部
      showBaseHeader: false,  // 是否显示基础头部，无任何点击事件的头部
      isShowReportAnalyze: false, //是否tab页打开的dna解析
      isShowBackBtn: false, //是否是scorm环境或其他第三方进来的，是的话不展示部分样式
    }
  },
  components: {
    BaseHeader,
    dropMenu,
    logo,
    HeaderTab
  },
  async created() {
    this.isShowReportAnalyze = this.$route.query.isShowReportAnalyze ? this.$route.query.isShowReportAnalyze : this.isShowReportAnalyze;
    // this.getImageIcon()
  },
  mounted() {
    console.log('getStore(\'userAuthority\')', getStore('userAuthority'))
    console.log('this.$store.state.user.userAuthority', this.$store.state.user.userAuthority)
    this.commonAuthority = getStore('userAuthority') ? JSON.parse(getStore('userAuthority')) : this.$store.state.user.userAuthority;
    if ((this.$route.query.linksource && this.$route.query.linksource == 'third') || sessionStorage.getItem('isShowBackList')) {
      this.setheader()
    }

    this.getUserAutherRouter = getSession('getUserAutherRouter');
    console.log('this.getUserAutherRouter', this.getUserAutherRouter)

    //如果有工具，获取工具状态
    if (this.commonAuthority.toolsAuthority) {
      this.haveToolsAuthority()
    }

    //判断是否在是SCROM环境隐藏返回按钮
    if (localStorage.getItem("source_env") == "LMS_SCORM") {
      this.isShowBackBtn = true;
    }

    if (
      process.env.ENV_CONFIG == 'devOverseas' ||
      process.env.ENV_CONFIG == 'prodOverseas' ||
      process.env.ENV_CONFIG == 'thdev' ||
      process.env.ENV_CONFIG == 'thuat' ||
      process.env.ENV_CONFIG == 'thprod'
    ) {
      this.languageMenu = {
        type: 'language',
        defaultValue: this.$t('language'),
        dropArr: [
          {
            name: '中文繁體',
            action: 'traditional',
            value: 'zh_TW',
          },
          {
            name: 'ภาษาไทย',
            action: 'thai',
            value: 'th_TH',
          },
        ],
      }
    } else {
      this.languageMenu = {
        type: 'language',
        defaultValue: this.$t('language'),
        dropArr: [
          {
            name: '中文简体',
            action: 'chinese',
            value: 'zh_CN',
          },
        ],
      }
    }
    this.setLanguageMenu()
    this.refreshUserMenu()
    this.$EventBus.$on('userInfoUpdated', this.refreshUserMenu)
    // this.getImageIcon()
    this.currentRoute = this.$route.path
  },
  beforeDestroy() {
    this.$EventBus.$off('userInfoUpdated', this.refreshUserMenu)
    removeSession('isHaveTools');
  },
  methods: {
    // 第三方设置项目头部，返回按钮
    setheader() {
      const self = this;
      self.showBaseHeader = true;
    },

    // 校验用户是否有权限有小工具
    haveToolsAuthority() {
      checkToolsAuthority().then((res) => { //res的值：0有 1没有 2有已过期
        setSession('isHaveTools', res);//这里的接口是为了点击时跳转
      })
    },
    clickTool() {
      buriedOperatingPoint('0', '点击【应用工具】菜单', '')
      const isHaveTools = getSession('isHaveTools')
      projectProgress().then((res) => {
        let str = ''
        let userInfo = JSON.parse(getStore('userInfo'))
        if (
          res.length === 0 ||
          res[0].learningPathMetasDetailList.length === 0
        ) {
          let userId = userInfo.userId
          setSession('learningPathMetas_' + userId, str)
        } else {
          const data = res[0].learningPathMetasDetailList
          for (let index = 0; index < data.length; index++) {
            const element = data[index]
            if (element.learningPathMetaId || element.learningPathMetaId == 0) { //独立作业没有learningPathMetaId
              str += element.learningPathMetaId + ','
            }
          }
          str = str.substr(0, str.length - 1)
          let userInfo = JSON.parse(getStore('userInfo'))
          if (userInfo) {
            let userId = userInfo.userId
            setSession('learningPathMetas_' + userId, str)
          }
        }
        if (
          this.currentRoute !== '/applicationTool' &&
          this.currentRouteName !== 'applicationTool'
        ) {
          if (isHaveTools === "1") {
            console.log('进入工具页')
            this.$router.push({
              name: "toolMagazine",
              query: {
                select: 0
              }
            });
          } else if (isHaveTools === "2") {
            this.$router.push({path: "/applicationToolTips"});
          }
        }
      })
    },
    async clickCoachPlatform() {
      let author = await this.getUserAuthority();//调用全局权限接口
      if (author.coachAuthority) {
        //没有学习中心只有教练，直接进入教练
        this.$router.replace({
          path: "/coachPlatform",
          query: {
            isOutlink: true,
            coachToken: getStore('transtalen-token'),
            isExpired: author.coachExpired
          }
        }).then(()=> {
          window.location.reload(true);
        });
      }
    },
    setLanguageMenu() {
      let localeLanguage = getStore('localeLanguage')
      this.ifMainlandVersion = localeLanguage == 'zh_CN' ? true : false
      for (let index = 0; index < this.languageMenu.dropArr.length; index++) {
        let element = this.languageMenu.dropArr[index]
        if (element.value == localeLanguage) {
          element['select'] = true
        } else {
          element['select'] = false
        }
      }
      let dropArrTemp = clone(this.languageMenu.dropArr)
      this.languageMenu.dropArr = []
      this.languageMenu.dropArr = dropArrTemp
      // console.log("this.languageMenu==", this.languageMenu)
      // this.getImageIcon()
    },
    clickLogo() {
      //如果学习中心没有权限 || 当前页是公司列表页 || 是否是新开tab打开的DNA报告页 || scorm包或者第三方平台
      if (!this.commonAuthority.learningCenterAuthority || this.currentRoute == '/companyList' || this.$route.query.isShowReportAnalyze ||
        this.isShowBackBtn) {
        return;
      }
      if (this.$router.history.current.name == 'home') {
        window.location.reload()
        return
      }
      this.$router.replace({path: '/home'})
    },
    getHeaderCourseInfo(item) {
      setSession('learningPathMetaId', item.id)
      let courseList = this.$store.state.user.courseList
      for (let index = 0; index < courseList.length; index++) {
        let element = courseList[index]
        if (element.id == item.id) {
          element['select'] = true
        } else {
          element['select'] = false
        }
      }
      setTimeout(() => {
        this.$store.dispatch('setCourseList', courseList)
      }, 300)
    },
    courseDrop(item) {
      console.log('item', item)
      // console.log("(this.$router===", this.$router)
      this.getHeaderCourseInfo(item)
      let queryData = {id: item.id}
      if (this.$router.history.current.name == 'overview') {
        this.$EventBus.$emit('refreshOverview', {queryData})
        window.scroll(0, 0)
        document.body.scrollTop = 0
        return
      }
      window.scroll(0, 0)
      document.body.scrollTop = 0

      // 直接跳转到课程里面
      console.log('item--', item)
      if (item.id == 0) {
        this.$router.push({
          path: "/leadershipDNA",
          query: {progress: item.progress},
        });
      } else {
        console.log('currentcurrent', this.$router.history.current)

        if (this.$router.history.current.fullPath.indexOf('/course') != -1) {
          console.log('yyyyyyy')

          this.$EventBus.$emit('refreshCourse', {queryData})
          window.scroll(0, 0)
          document.body.scrollTop = 0
          return
        }
        console.log('nnnnnnnn')

        this.$router.replace({path: '/course', query: {id: item.id}})
      }
    },
    userDrop(item) {
      switch (item.action) {
        // 数据权益处理请求
        case 'data':
          this.$router.push({path: '/datahandle'})
          break
        //切换至公司列表
        case 'companyList':
          // 已登录切公司须保留正式 token，选公司时随 login body 回传（只校验 token）
          this.$router.replace({path: '/companyList'})
          removeStore('userAuthority');
          break
        // 退出登录
        case 'logout':
          logout({}, JSON.parse(getStore('userInfo')).type).then((res) => {
            this.clearGlobalStorage();
          })
          this.$router.replace({path: '/'})
          break
        // 使用条款
        case 'useTerms':
          getTerms()
          break
        // 用户隐私政策
        case 'privacy':
          getPrivacy()
          break
        default:
          break
      }
    },
    refreshUserMenu() {
      try {
        const raw = getStore('userInfo')
        this.userInfo = raw && raw !== 'null' ? JSON.parse(raw) : {}
      } catch (e) {
        this.userInfo = {}
      }
      const cachedList = this.readCachedCompanyList()
      if (
        cachedList &&
        cachedList.length > 0 &&
        !(this.userInfo.companyList && this.userInfo.companyList.length > 0)
      ) {
        this.userInfo.companyList = cachedList
      }
      this.getUserDropArr()
    },
    readCachedCompanyList() {
      try {
        const raw = getStore('loginCompanyList')
        if (!raw || raw === 'null') return []
        const list = JSON.parse(raw)
        return Array.isArray(list) ? list : []
      } catch (e) {
        return []
      }
    },
    getUserDropArr() {
      if (this.userInfo) {
        if (this.userInfo.companyList && this.userInfo.companyList.length > 0) {
          let arr = [
            {
              name: this.$t('switchCompany'),
              action: 'companyList',
            },
            {
              name: this.$t('dataHandle'),
              action: 'data',
            },
            {
              name: this.$t('useTerms'),
              action: 'useTerms',
            },
            {
              name: this.$t('userPrivacy'),
              action: 'privacy',
            },
            {
              name: this.$t('logout'),
              action: 'logout',
            },
          ]
          this.userMenu.dropArr = arr
        } else {
          let arr = [
            {
              name: this.$t('dataHandle'),
              action: 'data',
            },
            {
              name: this.$t('useTerms'),
              action: 'useTerms',
            },
            {
              name: this.$t('userPrivacy'),
              action: 'privacy',
            },
            {
              name: this.$t('logout'),
              action: 'logout',
            },
          ]
          this.userMenu.dropArr = arr
        }
      }
    },
    getImageIcon() {
      let imageLanguage = getImageLanguage()
      //  "zh_CN": "cn",//中文简体
      //     "en_US": "en",//英文
      //     "zh_TW": "tw",//中文繁体
      //     "th_TH": "th",//泰文
      // console.log("audioViewRef", imageLanguage, this.$refs.audioViewRef)
      switch (imageLanguage) {
        case 'cn':
          this.imgIcon = require('../../assets/image/home/left_logo_icon.png')
          break
        case 'en':
          this.imgIcon = require('../../assets/image/home/left_logo_icon.png')
          break
        case 'tw':
          this.imgIcon = require('../../assets/image/home/tip_info_img_tw.jpg')
          break
        case 'th':
          this.imgIcon = require('../../assets/image/home/left_logo_icon.png')
          break
        default:
          break
      }
    },
    tabClick(item) {
      switch (item) {
        case 'learningCenterAuthority':
          this.clickLogo();
          break;
        case 'coachAuthority':
          this.clickCoachPlatform();
          break;
        case 'toolsAuthority':
          this.clickTool();
          break;
      }
    }
  },
}
</script>

<style lang='scss' scoped>
.container {
  width: 100%;
  height: var(--height-56);
  background: #ffffff;
  border-bottom: 1px solid var(--color-gray-line-deep);
  //box-shadow: 0 0.0125rem 0.05rem 0 rgba(211, 211, 211, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.top-nav-view {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100%;
}

.left-top-view {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  // cursor: pointer;

  .space_block {
    width: var(--width-60);
    height: var(--height-20);
  }
}

.margin-diot {
  margin: 0px 0.10625rem;
}

.right-top-view {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Header.vue